import * as actionTypes from "./actionTypes";

import axios from "../../services/apiClient";

export const uploadStart = () => {
  return {
    type: actionTypes.IMAGE_UPLOAD_START,
  };
};

export const uploadSuccess = (imgUrl) => {
  return {
    type: actionTypes.IMAGE_UPLOAD_SUCCESS,
    imgUrl,
  };
};

export const uploadFail = () => {
  return {
    type: actionTypes.IMAGE_UPLOAD_FAIL,
  };
};

export const uploadMultyStart = () => {
  return {
    type: actionTypes.IMAGE_MULTY_UPLOAD_START,
  };
};

export const uploadMultySuccess = (imgUrl) => {
  return {
    type: actionTypes.IMAGE_MULTY_UPLOAD_SUCCESS,
    imgUrl,
  };
};

export const uploadMultyFail = () => {
  return {
    type: actionTypes.IMAGE_MULTY_UPLOAD_FAIL,
  };
};

export const imageDeleteArrStart = () => {
  return {
    type: actionTypes.IMAGE_DELETE_ARR,
  };
};

export const imageDeleteArr = (img) => {
  return (dispatch) => {
    dispatch(imageDeleteArrStart());
  };
};

export const imageDeleteIndexArrStart = (index) => {
  return {
    type: actionTypes.IMAGE_DELETE_ARR_INDEX,
    index,
  };
};

export const imageDeleteIndexArr = (index) => {
  return (dispatch) => {
    dispatch(imageDeleteIndexArrStart(index));
  };
};

export const ImageUploader = (img) => {
  return async (dispatch) => {
    dispatch(uploadStart());

    try {
      // Store base64 image directly in Redux without API call
      // Images will be sent with product creation request
      const base64Image = JSON.parse(img);
      dispatch(uploadSuccess(base64Image));
    } catch (error) {
      console.error('Error parsing image:', error);
      dispatch(uploadFail());
    }
  };
};

export const ImageUploaderMulty = (img) => {
  return (dispatch) => {
    dispatch(uploadMultyStart());

    // Store base64 image directly in Redux without API call
    // Images will be sent with product creation request
    try {
      const base64Image = JSON.parse(img);
      dispatch(uploadMultySuccess(base64Image));
    } catch (error) {
      console.error('Error parsing image:', error);
      dispatch(uploadMultyFail());
    }
  };
};

export const fillArrayOfImages = (arr) => {
  return {
    type: actionTypes.IMAGE_FILL_ARRAY,
    arr,
  };
};

export const FillArray = (arr) => {
  return (dispatch) => {
    dispatch(fillArrayOfImages(arr));
  };
};

export const imageSetInitialArrAction = (arr) => {
  return {
    type: actionTypes.IMAGE_SET_INITIAL_ARR,
    arr,
  };
};

export const imageSetInitialArr = (arr) => {
  return (dispatch) => {
    dispatch(imageSetInitialArrAction(arr));
  };
};

export const imageClearArrAction = () => {
  return {
    type: actionTypes.IMAGE_CLEAR_ARR,
  };
};

export const imageClearArr = () => {
  return (dispatch) => {
    dispatch(imageClearArrAction());
  };
};
